import React from "react";

import { Column } from "@gamedev-web/gamedev-sdk-core";

import { sendAnotherRequest, success, successRequestMessage } from "../gdkMiddlewarePageContent";
import * as styles from "../GdkMiddlewareRequestPage.module.css";

export type SubmittedStepProps = {
  onStartOver: () => void;
};

export const SubmittedStep = ({ onStartOver }: SubmittedStepProps) => (
  <Column className={styles.innerContentBox}>
    <h4>{success}</h4>
    <p>{successRequestMessage}</p>
    <div>
      <button className={styles.actionButton} onClick={onStartOver}>
        {sendAnotherRequest}
      </button>
    </div>
  </Column>
);
